import React from 'react';
import { Star } from 'lucide-react';
import { Section } from './Shared';
export type TestimonialProps = {
  initials: string;
  name: string;
  location: string;
  product?: string;
  text: string;
};
export function TestimonialCard({
  initials,
  name,
  location,
  product,
  text
}: TestimonialProps) {
  return <article className="glass-panel flex h-full flex-col rounded-2xl p-6 md:p-8" data-id="element-278" data-mp="3azjdnwexoibo"><div className="mb-4 flex items-center" data-id="element-279" data-mp="36zilza2tqamo"><div className="mr-3 flex h-11 w-11 shrink-0 items-center justify-center rounded-full border border-brand-gold/40 bg-brand-green text-sm font-bold text-white md:mr-4 md:h-12 md:w-12 md:text-lg" data-id="element-280" data-mp="370kaag8uotmc">{initials}</div><div data-id="element-281" data-mp="2x11t27kbrlxz"><div className="mb-1 flex text-brand-gold" data-id="element-282" data-mp="2x11rw48l9fwe">{Array.from({
            length: 5
          }, (_, index) => <Star key={index} className="h-4 w-4 fill-current" data-id="element-283" data-mp="2s3t9c2jj39um" />)}</div><p className="font-semibold text-brand-text md:text-lg" data-id="element-284" data-mp="v8dkrjstq8bc">{name}</p><p className="text-xs text-brand-muted md:text-sm" data-id="element-285" data-mp="qac0wwnkq4yt">{location}{product ? ` — ${product}` : ''}</p></div></div><p className="flex-grow font-serif text-sm italic leading-relaxed text-brand-textLight md:text-base" data-id="element-286" data-mp="h681sb51o0dj">“{text}”</p></article>;
}
export function InitialTestimonials() {
  return <Section className="pb-16 pt-8" data-id="element-287" data-mp="m2onkyoru2ng"><div className="mx-auto max-w-3xl" data-id="element-288" data-mp="78a99bg5jhf4"><TestimonialCard initials="MG" name="María G." location="Córdoba" product="Terapeuta holística" text="Por primera vez tengo un sistema completo para planificar mis sesiones de ventosaterapia con criterio clínico real. Mis pacientes sienten la diferencia desde la primera semana y yo dejé de llegar al consultorio improvisando." data-id="element-289" data-mp="79bntpwdmm1l" /></div></Section>;
}
export function MoreTestimonials() {
  const testimonials: TestimonialProps[] = [{
    initials: 'MG',
    name: 'María G.',
    location: 'Córdoba',
    product: 'Terapeuta holística',
    text: 'Por primera vez tengo un sistema completo para mis sesiones. El Manual de Protocolo S.O.S. me cambió la forma de trabajar. Mis pacientes perciben la diferencia y cada vez que hay marcas, sé exactamente qué decirles.'
  }, {
    initials: 'JL',
    name: 'Julián L.',
    location: 'Buenos Aires',
    product: 'Masajista terapéutico',
    text: 'El Escudo Legal y Clínico me salvó. Antes trabajaba sin documentación y vivía con el miedo de que algo pasara. Ahora tengo todo firmado, registrado y en orden. Es otra sensación.'
  }, {
    initials: 'SM',
    name: 'Sofía M.',
    location: 'Rosario',
    product: 'Terapeuta en formación',
    text: 'Recién empezaba y el Megapack me dio la estructura que necesitaba desde el primer paciente. Los Scripts de WhatsApp y la Calculadora de Precios solos ya valen todo el pack.'
  }, {
    initials: 'DL',
    name: 'Diego L.',
    location: 'Tucumán',
    product: 'Terapeuta corporal',
    text: 'El Manual de Ventosas Faciales me abrió un servicio que no imaginaba ofrecer. Ahora trabajo estética facial y mis clientas repiten la sesión todos los meses.'
  }];
  return <Section className="pb-16 pt-8" data-id="element-290" data-mp="qt0ts3re43zm"><div className="mb-12 text-center" data-id="element-291" data-mp="quvh1oq4w86v"><h2 className="font-display text-2xl font-bold text-brand-greenDark md:text-4xl" data-id="element-292" data-mp="qvwq5nnlakly">❤️ LO QUE DICEN LOS TERAPEUTAS QUE YA LO TIENEN</h2></div><div className="mx-auto grid max-w-4xl grid-cols-1 gap-6 md:grid-cols-2" data-id="element-293" data-mp="37f7hgzzu14ze">{testimonials.map(testimonial => <TestimonialCard key={testimonial.initials} {...testimonial} data-id="element-294" data-mp="3cetqsycji12x" />)}</div></Section>;
}